import { Form, Select } from "antd";

const SelectField = ({ field }) => (
  <>
    <Form.Item
      hidden={field?.hidden}
      name={field.name}
      label={field.label}
      extra={field.extra}
      rules={field.rules}
    >
      <Select
        placeholder={`Select ${field.label}`}
        options={field.selectItems?.map((item) => ({
          label: item.label,
          value: item.name,
        }))}
        disabled={field.disabled}
        showSearch={field.searchable}
        filterOption={
          field.searchable
            ? (input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            : undefined
        }
      />
    </Form.Item>
  </>
);

export default SelectField;
